var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { clearViewAsLibrary } from "./viewAsLibrary";
var ACTIVE_ROLES_KEY = "activeRoles";
var ACTIVE_LIBRARY_KEY = "activeLibrarySourceId";
/**
 * Roles cached in sessionStorage, or undefined when the current user has not
 * been loaded yet in this session.
 */
export var readActiveRolesFromStorage = function () {
    var stored = sessionStorage.getItem(ACTIVE_ROLES_KEY);
    if (stored === null)
        return undefined;
    try {
        return JSON.parse(stored);
    }
    catch (_a) {
        return undefined;
    }
};
/**
 * Cache by key existence, not value truthiness: a user with no roles or no
 * active organization legitimately produces empty values.
 */
export var hasCachedActiveRoles = function () {
    return sessionStorage.getItem(ACTIVE_ROLES_KEY) !== null &&
        sessionStorage.getItem(ACTIVE_LIBRARY_KEY) !== null;
};
var inFlight = null;
var failedOnThisPage = false;
/**
 * Loads the active roles of the current user once per session.
 *
 * All concurrent callers (every `useActiveRoles` instance on the page, on every
 * render) share one request. Only a user actually read is cached in
 * sessionStorage. A failure resolves "no roles" and is remembered for this page
 * only, so later renders do not retry it but a reload does: stored as "no roles",
 * one aborted request (a reload while it was in flight) sent every later page of
 * the tab to the organization selection.
 */
export var loadActiveRoles = function (fetchUser) {
    var _a;
    if (hasCachedActiveRoles()) {
        return Promise.resolve((_a = readActiveRolesFromStorage()) !== null && _a !== void 0 ? _a : []);
    }
    if (failedOnThisPage)
        return Promise.resolve([]);
    if (inFlight)
        return inFlight;
    clearViewAsLibrary();
    inFlight = (function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchedUser, roles, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, fetchUser()];
                case 1:
                    fetchedUser = _d.sent();
                    if (!fetchedUser) {
                        throw new Error("Current user could not be read");
                    }
                    roles = (_a = fetchedUser.activeRoles) !== null && _a !== void 0 ? _a : [];
                    sessionStorage.setItem(ACTIVE_ROLES_KEY, JSON.stringify(roles));
                    sessionStorage.setItem(ACTIVE_LIBRARY_KEY, (_c = (_b = fetchedUser.activeOrganization) === null || _b === void 0 ? void 0 : _b.sourceId) !== null && _c !== void 0 ? _c : "");
                    return [2 /*return*/, roles];
                case 2:
                    error_1 = _d.sent();
                    console.error("Error fetching user:", error_1);
                    failedOnThisPage = true;
                    return [2 /*return*/, []];
                case 3:
                    inFlight = null;
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); })();
    return inFlight;
};
